<script>
import ImageGallery from '@/components/landing/ImageGallery.vue';

export default {
  name: 'AppIntro',

  components: {
    ImageGallery,
  },

  props: {
    onInstallPage: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    getApp() {
      const { $router, $store } = this;
      $router.push({ name: 'Install' });
      $store.dispatch('analytics/getAppClick', 'Landing_About_App');
    },
  },
};
</script>

<template>
  <section class="section" :class="{ 'install-page': onInstallPage }">
    <div class="description">
      <div class="logo-title">
        <div class="app-logo">
          <picture>
            <source
              :srcset="require('@/assets/logo/HotAirBalloonLogo-400h.webp')"
              type="image/webp"
            />
            <source
              :srcset="require('@/assets/logo/HotAirBalloonLogo-400h.png')"
              type="image/png"
            />
            <img :src="require('@/assets/logo/HotAirBalloonLogo-400h.png')" alt="App Screenshot" />
          </picture>
        </div>

        <h2 class="section-title">
          About the app
        </h2>
      </div>

      <ul>
        <li>60 cards to explore</li>
        <li>Daily cards to help get you through your morning, day, and night</li>
        <li>Save your favorites to come back to again and again</li>
        <li>Always ad-free, with an optional premium version for extra features</li>
      </ul>

      <p>
        This is a web app so it works on every device. It may take a couple of extra steps to
        install it, but once you do, it works just like other apps&mdash;even offline. Plus, you
        never have to install updates.
      </p>

      <div v-if="!onInstallPage" class="button-container">
        <v-btn
          large
          depressed
          color="primary"
          :ripple="{ class: 'primary--text' }"
          class="get-app-button"
          @click="getApp"
        >
          Get the app
        </v-btn>
      </div>

      <mq-layout :mq="['sm', 'md']">
        <ImageGallery :on-install-page="onInstallPage" />
      </mq-layout>

      <div class="title-container">
        <h4 class="regular-font premium-heading">
          Premium version
        </h4>
        <span class="label">Coming Soon</span>
      </div>

      <p>
        The premium version of Mindy&#39;s Imagination Cards is coming soon. With a premium
        membership, you&#39;ll get exclusive access to:
      </p>

      <ul>
        <li>Audio versions of the cards</li>
        <li>
          Curated collections of cards on themes like &quot;Falling asleep&quot; or
          &quot;Gratitude&quot;
        </li>
        <li>Create your own stacks of cards</li>
        <li>Bonus cards</li>
      </ul>
    </div>

    <mq-layout mq="lg+">
      <ImageGallery :on-install-page="onInstallPage" />
    </mq-layout>
  </section>
</template>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.section {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  box-sizing: border-box;

  .sm &,
  .md & {
    flex-direction: column;
    justify-content: flex-start;
  }
}

.section-title {
  width: fit-content !important;
}

.logo-title {
  display: flex;
  // flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 2rem;

  .app-logo {
    width: 2.7rem;
    min-width: 2.7rem;
    height: 2.7rem;
    margin-right: 1.5rem;
  }

  img {
    height: 100%;
    width: 100%;
  }
}

.description {
  max-width: 40%;
  margin-right: 1rem;

  .sm &,
  .md & {
    max-width: 100%;
    margin-right: 0;
  }

  p {
    text-indent: 0;
  }
}

.title-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 1.5rem;
  margin-bottom: 0.75rem;

  h4 {
    display: inline-block;
  }

  .sm &,
  .md & {
    flex-direction: column;
  }
}

.label {
  display: inline-block;
  padding: 0.25rem 0.5rem;
  margin: 0.5rem 1.5rem;
  margin-right: 0;
  background-color: $yellow-light;
  font-size: 80%;
  text-align: center;

  .sm &,
  .md & {
    margin: 0.5rem 0;
  }
}

ol {
  margin-top: 0.5rem;
  margin-bottom: 1rem;
}

ol,
ul {
  margin-left: 1.5rem;
}

li {
  line-height: 1.4em;
  margin-bottom: 0.75rem;
}

.install-page {
  .logo-title {
    .lg &,
    .xl & {
      justify-content: flex-start;
    }
  }

  .section-title {
    font-size: 2rem;
  }

  .description {
    max-width: 100%;
  }
}
</style>
